import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Flame, Settings } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { getSettings, greeting, blessingLine, markShown } from "@/lib/blessing";

export const LampFlame = ({ size = 96 }) => (
  <div className="relative grid place-items-center" style={{ width: size * 2, height: size * 2 }}>
    <div className="eb-glow" />
    <Flame size={size} className="eb-flame-icon" style={{ color: "var(--player-accent)" }} fill="currentColor" />
  </div>
);

export const BlessingOverlay = ({ onClose, onLight }) => {
  const { t, lang } = useLang();
  const s = getSettings();

  useEffect(() => {
    const h = (e) => { if (e.key === "Escape") { markShown(); onClose(); } };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-50 grid place-items-center px-4" style={{ background: "rgba(12,10,8,0.82)", backdropFilter: "blur(6px)" }} data-testid="blessing-overlay"
      onClick={(e) => { if (e.target === e.currentTarget) { markShown(); onClose(); } }}>
      <div className="w-full max-w-md rounded-3xl p-8 text-center sk-scale-in" style={{ background: "var(--player-bg)", border: "1px solid rgba(255,255,255,0.1)" }}>
        <div className="flex justify-center mb-2"><LampFlame size={84} /></div>
        <p className="font-ui text-xs font-bold tracking-widest uppercase mb-3" style={{ color: "var(--player-accent)" }}>{t("eb_title")}</p>
        <h2 className={`${lang === "si" ? "font-si" : "font-en"} text-2xl sm:text-3xl font-bold`} style={{ color: "var(--player-text)" }}>{greeting(s, lang)} 🪔</h2>
        <p className={`${lang === "si" ? "font-si" : "font-en"} text-lg mt-4 leading-relaxed`} style={{ color: "rgba(255,255,255,0.82)" }}>{blessingLine(s.tradition, lang)}</p>
        <button onClick={() => { markShown(); onLight(); }} data-testid="blessing-light-button" className="mt-7 w-full h-14 rounded-full font-ui text-lg font-bold flex items-center justify-center gap-2 transition-transform active:scale-95 sk-glow" style={{ background: "var(--player-accent)", color: "var(--player-bg)" }}>
          <Flame size={22} fill="currentColor" /> {t("eb_light")}
        </button>
        <div className="flex items-center justify-between mt-4">
          <button onClick={() => { markShown(); onClose(); }} data-testid="blessing-notnow-button" className="font-ui text-sm font-semibold" style={{ color: "rgba(255,255,255,0.6)" }}>{t("eb_not_now")}</button>
          <Link to="/rooms/sindu-kamare/evening" onClick={() => { markShown(); onClose(); }} className="font-ui text-sm font-semibold flex items-center gap-1" style={{ color: "var(--player-accent)" }}><Settings size={14} /> {t("eb_settings")}</Link>
        </div>
      </div>
    </div>
  );
};
